export const CAPTION = 'image-caption';
